import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { COLORES_AVISO } from './GrillaAvisosAnses';
import { obtenerAvisosDeTodos, guardarAvisosDeUsuario } from '../../services/avisosAnsesService';

// Solo mail: la campana del seguimiento se sacó el 26-oct-2026 (no se usaba).
const CANALES = [
    { campo: 'email', icono: 'bi-envelope', nombre: 'mail' },
];

/**
 * Configuración de admin: qué avisos de ANSES recibe cada usuario y por dónde. Cada casilla se
 * guarda al tocarla. Los avisos solo llegan de lo que cada uno sigue (trámites o clientes con
 * estrella); acá se decide de qué tipo y por qué canal.
 */
export default function AvisosPorUsuario() {
    const [filas, setFilas] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [guardando, setGuardando] = useState(null);
    const [filtro, setFiltro] = useState('');

    const cargar = useCallback(async () => {
        try {
            const data = await obtenerAvisosDeTodos();
            setFilas(Array.isArray(data) ? data : []);
        } catch {
            toast.error('No se pudieron cargar los avisos por usuario');
        } finally {
            setCargando(false);
        }
    }, []);

    useEffect(() => { cargar(); }, [cargar]);

    const tipos = filas[0]?.preferencias || [];

    const cambiar = async (fila, tipo, campo, valor) => {
        const nuevas = fila.preferencias.map((p) => (p.tipo === tipo ? { ...p, [campo]: valor } : p));
        setGuardando(fila.idUsuario);
        try {
            const guardadas = await guardarAvisosDeUsuario(fila.idUsuario, nuevas);
            setFilas((prev) => prev.map((f) => (f.idUsuario === fila.idUsuario ? { ...f, preferencias: guardadas } : f)));
        } catch {
            toast.error(`No se pudo guardar el aviso de ${fila.nombre}`);
        } finally {
            setGuardando(null);
        }
    };

    const visibles = useMemo(() => {
        const t = filtro.trim().toLowerCase();
        return t ? filas.filter((f) => `${f.nombre} ${f.rol || ''}`.toLowerCase().includes(t)) : filas;
    }, [filas, filtro]);

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                <h6 style={{ margin: 0 }}>Avisos por usuario</h6>
                <input className="form-control form-control-sm" style={{ maxWidth: 220 }} placeholder="Buscar usuario…"
                    value={filtro} onChange={(e) => setFiltro(e.target.value)} aria-label="Buscar usuario" />
            </div>
            <p style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>
                Qué novedades de ANSES le llegan a cada usuario por mail <i className="bi bi-envelope" />.
                Solo de los trámites y clientes que sigue. Empiezan todos apagados; cada uno también puede cambiar los suyos desde Para aprobar → Mis avisos.
            </p>
            {cargando ? (
                <p style={{ color: '#888780' }}>Cargando…</p>
            ) : (
                <div style={{ maxHeight: 420, overflowY: 'auto' }}>
                    <table className="table table-sm table-hover" style={{ fontSize: 13 }}>
                        <thead>
                            <tr>
                                <th>Usuario</th>
                                {tipos.map((t) => (
                                    <th key={t.tipo} className="text-center" style={{ color: COLORES_AVISO[t.tipo] }}>{t.etiqueta}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {visibles.map((f) => (
                                <tr key={f.idUsuario} style={{ opacity: guardando === f.idUsuario ? 0.6 : 1 }}>
                                    <td>
                                        <div style={{ fontWeight: 600 }}>{f.nombre}</div>
                                        <div style={{ fontSize: 11, color: '#888780' }}>{f.rol}</div>
                                    </td>
                                    {f.preferencias.map((p) => (
                                        <td key={p.tipo} className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                            {CANALES.map((c) => (
                                                <label key={c.campo} className="me-2" title={`${p.etiqueta} por ${c.nombre}`} style={{ cursor: 'pointer' }}>
                                                    <input
                                                        type="checkbox" className="form-check-input me-1"
                                                        aria-label={`${f.nombre}: ${p.etiqueta} por ${c.nombre}`}
                                                        checked={Boolean(p[c.campo])}
                                                        disabled={guardando === f.idUsuario}
                                                        onChange={(e) => cambiar(f, p.tipo, c.campo, e.target.checked)}
                                                    />
                                                    <i className={`bi ${c.icono}`} />
                                                </label>
                                            ))}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
